import { format, formatDistance } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { Timestamp } from 'firebase/firestore';

export const useFormatDate = () => {
  /**
   * Format a date to relative time (e.g. "2 hours ago")
   */
  const formatRelativeTime = (date: Date | Timestamp) => {
    const dateToFormat = date instanceof Timestamp ? date.toDate() : date;
    return formatDistance(dateToFormat, new Date(), {
      addSuffix: true,
      locale: enUS,
    });
  };

  /**
   * Format a date to a specific format
   */
  const formatDateTime = (date: Date | Timestamp, formatStr: string = 'PPpp') => {
    const dateToFormat = date instanceof Timestamp ? date.toDate() : date;
    return format(dateToFormat, formatStr, {
      locale: enUS,
    });
  };

  return {
    formatRelativeTime,
    formatDateTime,
  };
};
